import { IAddressEntity } from '../../models/address';
import {
  IAppointmentBase,
  IAppointmentProductBase,
} from '../../models/appointments';
import { IUserBase } from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IUpdateAppointmentProduct {
  id?: string;
  costCenter: string;
  description?: string;
  finishAt?: string;
  name: string;
  price: number;
  productCode: string;
  productId: string;
  productNature: string;
  productType: string;
  invoiceType: 'NF' | 'ND';
  quantity: number;
  startAt?: string;
}

interface IUpdateAppointment {
  appointmentId: string;
  userId: string;
  products: IUpdateAppointmentProduct[];
  description?: string;
}

interface IAppointmentVenture extends IVentureBase {
  address?: IAddressEntity;
}

export interface IUpdatedAppointment extends IAppointmentBase {
  user: IUserBase;
  products: IAppointmentProductBase[];
  venture: IAppointmentVenture;
}

export const updateAppointmentsService = async ({
  appointmentId,
  userId,
  products,
  description,
}: IUpdateAppointment): Promise<IUpdatedAppointment> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedAppointment>(
    `/appointments/${appointmentId}`,
    {
      userId,
      products,
      description,
    },
  );

  return data;
};
